const ALL_SELECT_FILTER_ITEM = { label: 'All', value: null }

export default ALL_SELECT_FILTER_ITEM
